import { Select } from "antd";
import { Controller, UseFormReturn } from "react-hook-form";
const { Option } = Select;

type Props = {
  form: UseFormReturn<any>;
  fieldName: string;
  members: { id: string; name: string }[];
  defaultMemberId: string;
  readOnly: boolean;
};
export default function DiscordMemberSingleSelector({
  form,
  members,
  fieldName,
  defaultMemberId,
  readOnly,
}: Props) {
  const defaultMember = members.find((member) => {
    return member.id === defaultMemberId;
  });

  return (
    <Controller
      control={form.control}
      name={fieldName}
      render={({ field }) => (
        <Select
          disabled={readOnly}
          placeholder={"Select a member"}
          onChange={field.onChange}
          defaultValue={defaultMember?.id || null}
          className="w-full"
        >
          {members.map((member) => {
            return (
              <Option
                key={member.id}
                value={member.id}
                name={member.id}
                id={member.id}
              >
                {member.name}
              </Option>
            );
          })}
        </Select>
      )}
    />
  );
}
